import { render } from "./IndustryMap.vue?vue&type=template&id=684731fd&scoped=true"
import script from "./IndustryMap.vue?vue&type=script&lang=js"
export * from "./IndustryMap.vue?vue&type=script&lang=js"

import "./IndustryMap.vue?vue&type=style&index=0&id=684731fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684731fd"]])

export default __exports__